import React from 'react';
import { BrowserSizeProvider } from './BrowserSize';

export const AppProviders = ({ children }: { children: JSX.Element }) => {
  return <BrowserSizeProvider>{children}</BrowserSizeProvider>;
};
